<template>
	<div>
	  <Header title="教学进度管理" type="0" route="/teacher/jxjdgl"></Header>
	  <div class="teachingProcess">
		<NOdata
		  title="暂无数据~"
		  v-if="this.pageData && this.pageData.length == 0"
		></NOdata>
		<div class="list-head">
			<p>{{itemObj.kcmc}}</p>
			<ul>
				<li>开课单位：{{itemObj.dwmc}}</li>
				<li>上课班级：{{itemObj.ktmc}}</li>
			</ul>
			<div class="xsdiv">
				<div><p>上课人数：{{itemObj.xkrs}}</p></div>
				<div><p>总学时：{{itemObj.skxs}}</p></div>
			</div>
		</div>

	

		<div class="content">
			<div class="tittlediv">
			录入列表
		</div>
		  <div v-for="(item, index) in pageData" :key="index">
			<p><i class="month-arrow"></i>第{{ item.zc }}周</p>
			<ul>
			  <li>上课时间：{{ item.kcsj }}</li>
			  <li>上课地点：{{ item.jsmc }}</li>
			  <li>填写情况：<label v-if="item.islr=='1'">已填写</label><label v-else style="color:red">未填写</label></li>
			</ul>
			<div class="butomdiv" v-if="item.islr=='0'">
				<span  class="spanone" @click="toTxContext(item,'0')">填写</span>
			</div>
			<div class="butomdiv" v-else>
				<span  class="spanone" @click="toTxContext(item,'1')">修改</span>
				<span class="spantow" @click="toSeeContext(item)">查看</span>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </template>
  
  <script>
  import { Api } from "../../../utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		title: "",
		jx0404id:this.$route.query.jx0404id,
		itemObj:JSON.parse(this.$route.query.itemObj)
	  };
	},
	methods: {
		toTxContext(item,isedit) {
		// 跳转教学进度界面
		this.$router.push({
		  path: "/teacher/jxjdgl_dataEdatOrAdd",
		  query: {
			jx0404id:item.jx0404id,
			week:item.zc,
			classTime:item.kcsj,
			classTableId:item.jx0408id,
			itemObj:JSON.stringify(this.itemObj),
			isedit:isedit
		  }
		});
	  },
	  toSeeContext(item){
		this.$router.push({
		  path: "/teacher/jxjdgl_dataViwe",
		  query: {
			jx0404id:item.jx0404id,
			week:item.zc,
			classTime:item.kcsj,
			classTableId:item.jx0408id,
			itemObj:JSON.stringify(this.itemObj)
		  }
		});
	  },
	  async initData(){
		const params = {
        jx0404id: this.jx0404id
      };
	  
		const res = await Api.findSkjhByBzd(params);
		if(res.code=='1'){
			this.pageData = res.data;
		}
	  }
	},
	created() {
		this.initData();
	}
  };
  </script>
  <style scoped lang="less" >
  .teachingProcess {
	padding: 3% 5% 0;
	padding-top: 0 ;
	.list-head {
	  height: auto;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 4% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  z-index: 1;
	  padding-bottom: 55px;
	  p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
	  }

	
	  span {
      position: absolute;
      top: 25%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }
	ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}

	.xsdiv{
		background-color: rgba(143, 135, 249, 0.8);
		border-radius: 8px;
		height: 42px;
		line-height: 42px;
		margin-top: 10px;
		div{
		  width: 50%;
		  float: left;
		}
		p{
			font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  opacity: 0.8;
		  display:inline-block;
		 padding-left: 10px;
		}

	}
	}
  
	.month-arrow{
		display: block;
		background: url(../../../../static/images/请销假.png)no-repeat center;
		background-size: 100%;
		width: 21px;
		height: 21px;
		float: left;
  }
	
	.content {
		position: relative;
		border-radius:  14px 14px 0px 0px;
		z-index: 2;
	  div {
		background: #f8f8f8;
		border-radius: 5px;
		padding: 3% 0 3% 6%;
		margin-bottom: 5%;
		position: relative;
  
		p {
		  height: 22px;
		  font-family: PingFangSC-Medium;
		  font-size: 16px;
		  color: #333333;
		  letter-spacing: 0;
		  font-weight: bolder;
		  margin-bottom: 2%;
		}
  
		ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 12px;
		  color: #666666;
		  letter-spacing: 0;
		  font-weight: 400;
		  margin-bottom: 1%;
		}
		
	  }

	  .tittlediv{
		background-color: #fff;
		margin-bottom: 0;
		padding-bottom:0 ;
		border-radius:  14px 14px 0px 0px;
		height: 35px;
		line-height: 35px;
		margin-top: -40px;
		font-family: PingFangSC-SNaNpxibold;
		font-weight: 800;
		font-size: 16px ;
		color: #333333;
		letter-spacing: 0;
		
	}

	  .butomdiv{
		.spanone {
		  position: absolute;
		  top: calc(50% - 6px);
		  right: 10px;
		  color: #fff;
		  background-color: rgb(116, 105, 248);
		  border-radius: 16px;
          font-size: 15px;
		  display: block;
		  width: 80px;
		  height: 30px;
		  line-height: 30px;
		  text-align: center;
		}

		.spantow {
		  position: absolute;
		  top: calc(50% - 6px);
		  right: 95px;
		  color: #fff;
		  background-color: rgb(116, 105, 248);
		  border-radius: 16px;
          font-size: 15px;
		  display: block;
		  width: 80px;
		  height: 30px;
		  line-height: 30px;
		  text-align: center;
		}
	  }
	}
  }
  .more.van-popup.van-popup--bottom {
	border-radius: 0 !important ;
  }
  .more {
	padding: 5% 0 5% 0;
	box-sizing: border-box;
	overflow: hidden;
	.van-tabs__content--animated {
	  height: 75vh;
	  overflow: auto;
	}
	.van-tabs--line .van-tabs__wrap {
	  border-bottom: 1px solid #f4f4f4;
	  .van-tab--active {
		.van-tab__text--ellipsis {
		  color: #212f6e !important;
		}
	  }
	  .van-tab__text--ellipsis {
		height: 20px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #8f95b5;
		text-align: center;
		letter-spacing: 0;
	  }
	  .van-tabs__line {
		background-color: #7469f8 !important;
		width: 25px;
		height: 3px;
		border-radius: 1.5px;
	  }
	}
	& > p {
	  width: 64px;
	  font-weight: bolder;
	  font-family: PingFangSC-Medium;
	  font-size: 16px;
	  color: #000000;
	  letter-spacing: 0;
	  text-align: center;
	  padding-left: 7%;
	}
	ul {
	  overflow: auto;
	  height: 36vh;
	  .choose {
		background-color: #f8f8f8;
	  }
	  li {
		height: 40px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #212f6e;
		font-weight: bold;
		display: flex;
		align-items: center;
		padding-right: 5%;
		padding-left: 7%;
		justify-content: space-between;
	  }
	}
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/teacher/jxjdgl/jxjdgl_deallist.vue